import PropTypes from 'prop-types';
import MessageContent from '../message/MessageContent';

const TableSection = ({ results }) => {
  return (
    <div className="mt-2">
      <MessageContent 
        content={results} 
        type="table" 
      />
    </div>
  );
};

TableSection.propTypes = {
  results: PropTypes.object.isRequired
};

export default TableSection; 